export default {
    'InsertUnameEmail':     'Inserisci username o indirizzo email',
    'ChangePass':           'Cambia password',
    'UnameOrEmail':         'Username o email',
    'PassRecover':          'Recupera password',
    'InsertCurrPass':       'Inserisci la password attuale',
    'CurrentPass':          'Password attuale',
    'NewPass':              'Nuova password',
    'CreateNewPass':        'Scegli una nuova password',
    'ConfirmNewPass':       'Conferma la nuova password',
    'show_pass':            'Mostra la password',
    'hide_pass':            'Nascondi la password',
    'RequiredField':        'Campo obbligatorio',
    'PassDontMatch':        'Nuova password e conferma devono essere uguali',
    'PassReq1':             'Non può essere troppo comune',
    'PassReq2':             'Deve contenere almeno 12 caratteri',
    'PassReq3':             'Non può essere interamente numerica',
    'SuccessMailSent':      'Abbiamo inviato un\'email all\'utente o all\'indirizzo email indicato, segui le istruzioni allegate per creare una nuova password',
    'SuccessMailSent2':     'Se non l\'hai ricevuta contatta il Supporto Tecnico',
    'SuccessPassReset':     'La password è stata aggiornata con successo',
    'Send':                 'Invia',
    'UnknownError':         'Si è verificato un errore imprevisto, riprova più tardi.',
    'Language':             'Lingua'
}
